// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { Hierarchy, Danger, MoneyTick } from 'iconsax-react';

// icons — one relevant icon per destination
const icons = {
  workflows: Hierarchy,
  violations: Danger,
  hvcConfig: MoneyTick,
};

// ==============================|| MENU ITEMS - STORE OPERATIONS ||============================== //
// Workflow definitions and violations. Tickets are promoted to their own
// top-level group (see `menu-items/tickets.js`).

const storeOperations = {
  id: 'group-store-operations',
  title: <FormattedMessage id="Store Operations" />,
  icon: icons.workflows,
  type: 'group',
  children: [
    {
      id: 'workflows',
      title: <FormattedMessage id="Workflows" />,
      type: 'item',
      icon: icons.workflows,
      url: '/workflows/list',
    },
    {
      id: 'violations',
      title: <FormattedMessage id="Violations" />,
      type: 'item',
      icon: icons.violations,
      url: '/violations',
    },
    {
      id: 'hvc-config',
      title: <FormattedMessage id="HVC Config" />,
      type: 'item',
      icon: icons.hvcConfig,
      url: '/hvc-config',
    },
  ],
};

export default storeOperations;
